import React from 'react';
import {Tabs} from 'antd';
import CertificateList from './certificateList';
import CertificateDetails from './certificateDetails';

const { TabPane } = Tabs;
class CertificateManage extends React.Component{
  
    constructor(props) {
      super(props);  
      this.state={
        activeKey:"1",
        params:null
      }
    }
      callback(activeKey,type,params){
          if(type == "details"){
            this.state.params = params
          }
          if(type == "add"){
            this.state.params = null
          }
        this.setState({activeKey:activeKey})
      }
    render(){
        return(
          <div>
            <Tabs type="card" activeKey={this.state.activeKey} onChange= {this.callback.bind(this)}>
            <TabPane tab="证书列表" key="1">
              <CertificateList  buttonList={this.props.buttonList} callback = {this.callback.bind(this)}/>
            </TabPane>
            <TabPane tab="证书上传" key="2">
              <CertificateDetails  buttonList={this.props.buttonList} params = {this.state.params} callback = {this.callback.bind(this)}/>
            </TabPane>
          </Tabs>
          </div>
        )
    }
}
export default CertificateManage;